export class Email {
	to: string;
    subject:  string;	
    content: string;	 
}